import { render } from "./RegTransfer.vue?vue&type=template&id=24491ecf"
import script from "./RegTransfer.vue?vue&type=script&lang=js"
export * from "./RegTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__